/* eslint-disable no-useless-escape */

export const NUMERIC_PATTERN = new RegExp(/\d+/g);
export const NON_NUMERIC_PATTERN = new RegExp(/\D+/g);

export const BSB_PATTERN = new RegExp(/^\d{3}-?\d{3}$/);
export const MASTERCARD_PATTERN = new RegExp(
  /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/
);
export const VISA_PATTERN = new RegExp(/^4/);

/**
 * This regex validate pattern dd/MM/yyyy also considers leap year
 */
export const DATE_PATTERN = new RegExp(
  /(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/
);

export const PHONE_PATTERN = new RegExp(/(?:^0[2378][0-9]{8})$|(?:^04\d{8}$)/g);
export const LANDLINE_PATTERN = new RegExp(/(?:^0[2378]\d{8}$)/);
export const MOBILE_PATTERN = new RegExp(/(?:^04\d{8}$)/);
export const EMAIL_PATTERN = new RegExp(
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g
);

export const HCC_PATTERN = new RegExp(/^\d{9}[a-zA-Z]{1}$/);
export const QSC_PATTERN = new RegExp(/^\d{8}$/);
export const DVA_PATTERN = new RegExp(/^[a-zA-Z]{1}[a-zA-Z\d]{5,8}$/);

export const STREET_NUMBER_PATTERN = new RegExp(
  /^[0-9]+([a-zA-Z]?|([-]{1}[0-9]+))?$/
);

export const AUSTRALIAN_PASSPORT_NUMBER_PATTERN = new RegExp(
  /^[A-Za-z]{1,2}[0-9]{7}$/
);

export const CURRENCY_PATTERN = new RegExp(/^\d+(\,\d{3})*(\.\d{2})$/g);

export const APARTMENT_PATTERN = new RegExp(/^(?!apartment$)/g);

export const DEGREE_PATTERN = new RegExp(/^(?:0|[1-3]?\d|[4][0])°$/g);
